import { render, staticRenderFns } from "./flow1.vue?vue&type=template&id=4cc32c26&scoped=true&"
import script from "./flow1.vue?vue&type=script&lang=js&"
export * from "./flow1.vue?vue&type=script&lang=js&"
import style0 from "./flow1.vue?vue&type=style&index=0&id=4cc32c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc32c26",
  null
  
)

export default component.exports